import axiosClient from './axiosClient';

const servicesApi = {
  // Catalogo publico de servicios (sin autenticacion), mostrado en "/servicio-tecnico"
  getCatalog: (search) => axiosClient.get('/catalog/services', { params: { search } }),

  // CRUD administrativo del catalogo de servicios (administrador y tecnico)
  getServices: (params) => axiosClient.get('/services', { params }),
  createService: (data) => axiosClient.post('/services', data),
  updateService: (id, data) => axiosClient.put(`/services/${id}`, data),
  deleteService: (id) => axiosClient.delete(`/services/${id}`),
};

export default servicesApi;
